import React, { useEffect } from "react";
import styled from "styled-components";
import { useHistory } from "react-router-dom";

import { useTheme, useLoyalty } from "../../../hooks";

//svgs
import { Body, Children, MainHolder, StyledText } from "../../../components/common/basic";
import { logEvent } from "firebase/analytics";
import analytics from "../../../context/analytics";
import { BackButton } from "../../../components/common";
import RewardItemCard from "../mashupnwin/components/RewardItemCard";

const CapturenShareHistory = () => {
  const { themeContext, theme } = useTheme();
  const {
    captureEntries,
  } = useLoyalty();

  useEffect(() => {
    analytics().then((anl) =>
      logEvent(anl, "screen_view", {
        firebase_screen: "CaptureAndShareHistory",
        firebase_screen_class: "CaptureAndShareHistory",
      })
    );
  }, []);

  const history = useHistory();

  let themeColor = "background";
  let background = theme.colors[themeContext.activeTheme][themeColor];
  return (
    <>
      <MainHolder>
        <Children>
          <BackButton
            onClick={() => {
              history.push("/capturenshare")
            }}
          />
          <Header>
            <div style={{ textAlign: 'center' }}>
              <StyledText size={24} style={{ fontFamily: 'MTNMedium' }} margin="0">Track reward</StyledText>
            </div>
          </Header>
          <Body>
            <div style={{ boxSizing: 'border-box', padding: '0 15px' }}>
              {
                captureEntries &&
                captureEntries.map((captureHistoryItem) => {
                  const { item, uri } = captureHistoryItem;
                  return <RewardItemCard
                    onClick={() => {
                      history.push(`status?id=${captureHistoryItem?._id}`);
                    }}
                    color={background}
                    image={uri}
                    name={item}
                    points={"Won"}
                    showStatus={true}
                    status={'pending'}
                  />
                })
              }
            </div>
          </Body>
        </Children>
      </MainHolder>
    </>
  );
};

const Header = styled.div`
  /* width: 360px; */
  overflow: hidden;
  padding: 20px 20px 10px 20px;
  background-color: ${({ background }) => background};
  position: relative;
`;

export default CapturenShareHistory;
